[
  {
    "actionId": "initial",
    "actionName": "Initial",
    "input": {
      "FileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "FileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "convertToPdf",
    "actionName": "Convert to PDF",
    "input": {
      "FileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {
      "ExcludeAttachments": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "splitPdf",
    "actionName": "Split PDF",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "PdfFileIdsList": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "settings": {}
  },
  {
    "actionId": "forEachPdfFile",
    "actionName": "For each PDF file",
    "input": {
      "PdfFileIdsList": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {},
    "settings": {}
  },
  {
    "actionId": "renderPdfPage",
    "actionName": "Render PDF page",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "ImageId": {
        "type": "fileId",
        "isCollection": false
      },
      "HasGraphics": {
        "type": "boolean",
        "isCollection": false
      },
      "Dimensions": {
        "type": "dimensions",
        "isCollection": false
      },
      "HasLargeGraphics": {
        "type": "boolean",
        "isCollection": false
      },
      "IsTextAreaBelowThreshold": {
        "type": "boolean",
        "isCollection": false
      }
    },
    "settings": {
      "RenderDpiOverride": {
        "type": "integer",
        "isCollection": false
      },
      "RemoveText": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "ocrImage",
    "actionName": "OCR image",
    "input": {
      "ImageId": {
        "type": "fileId",
        "isCollection": false
      },
      "Dimensions": {
        "type": "dimensions",
        "isCollection": false
      }
    },
    "output": {
      "JsonFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "applyText",
    "actionName": "Apply Text",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "JsonFileIdsList": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "watermarkPdf",
    "actionName": "Watermark PDF",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "PageNumbersList": {
        "type": "boolean",
        "isCollection": true
      }
    },
    "output": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "extractPdfPageText",
    "actionName": "Extract PDF Page Text",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "JsonFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "combineTextLayers",
    "actionName": "Combine text layers",
    "input": {
      "OcrTextLayerJsonFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "TextLayerJsonFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "JsonFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "predictIdExist",
    "actionName": "Predict ID/Passport",
    "input": {
      "ImageId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "IdExists": {
        "type": "boolean",
        "isCollection": false
      },
      "Probability": {
        "type": "floatingNumber",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "classify",
    "actionName": "Classify document type",
    "input": {
      "JsonFileIdList": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "DocumentType": {
        "type": "classify",
        "isCollection": false
      }
    },
    "settings": {
      "Classifiers": {
        "type": "text",
        "isCollection": true
      },
      "Scope": {
        "type": "text",
        "isCollection": false
      },
      "UseLlmClassifiers": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "detectFaces",
    "actionName": "Detect faces in PDF page",
    "input": {
      "Dimensions": {
        "type": "dimensions",
        "isCollection": false
      },
      "ImageId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "DetectedObjects": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "settings": {}
  },
  {
    "actionId": "blurCoordinates",
    "actionName": "Blur Coordinates",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "DetectedObjects": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "output": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "detectBsn",
    "actionName": "Detect BSNs in text",
    "input": {
      "TextLayerJsonId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "DetectedObjects": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "settings": {}
  },
  {
    "actionId": "extractPii",
    "actionName": "Extract Pii data from MRZ",
    "input": {
      "JsonFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "ExtractedTargets": {
        "type": "piiExtractionTargets",
        "isCollection": true
      }
    },
    "settings": {
      "Targets": {
        "type": "text",
        "isCollection": true
      }
    }
  },
  {
    "actionId": "extractDataPerPage",
    "actionName": "Extract document data per page OBSOLETE",
    "input": {
      "JsonFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "DocumentType": {
        "type": "classify",
        "isCollection": false
      }
    },
    "output": {
      "ExtractedData": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "settings": {
      "Scope": {
        "type": "text",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "startIteration",
    "actionName": "Start iteration for each data file",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "endIteration",
    "actionName": "End iteration for data file",
    "input": {},
    "output": {},
    "settings": {}
  },
  {
    "actionId": "checkCondition",
    "actionName": "Check and verify condition",
    "input": {
      "ConditionInput": {
        "type": "any",
        "isCollection": false
      }
    },
    "output": {
      "ConditionResult": {
        "type": "boolean",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "extractData",
    "actionName": "Extract document data OBSOLETE",
    "input": {
      "JsonFileIdList": {
        "type": "fileId",
        "isCollection": true
      },
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "DocumentType": {
        "type": "classify",
        "isCollection": false
      }
    },
    "output": {
      "ExtractedDocumentData": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "settings": {
      "UseExperimentalFeatures": {
        "type": "boolean",
        "isCollection": false
      },
      "Scope": {
        "type": "text",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "extractDataV2",
    "actionName": "Extract document data",
    "input": {
      "JsonFileIdList": {
        "type": "fileId",
        "isCollection": true
      },
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "DocumentType": {
        "type": "classify",
        "isCollection": false
      }
    },
    "output": {
      "ExtractedData": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "settings": {
      "UseExperimentalFeatures": {
        "type": "boolean",
        "isCollection": false
      },
      "LlmExtractionType": {
        "type": "text",
        "isCollection": false
      },
      "Scope": {
        "type": "text",
        "isCollection": false
      },
      "EnabledMixedDocumentTypes": {
        "type": "text",
        "isCollection": true
      }
    }
  },
  {
    "actionId": "cutOutIds",
    "actionName": "Cut out ID",
    "input": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "TextLayerJsonId": {
        "type": "fileId",
        "isCollection": true
      },
      "DetectedObjects": {
        "type": "detectedObject",
        "isCollection": true
      },
      "DetectedQrCodes": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "output": {
      "CutOutIds": {
        "type": "cutOutId",
        "isCollection": true
      }
    },
    "settings": {
      "DisableVisualExtraction": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "createTextLayerSummary",
    "actionName": "Create full text summary",
    "input": {
      "JsonFileIdsList": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "JsonFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "assessRisk",
    "actionName": "Assess risk",
    "input": {
      "ExtractedTargets": {
        "type": "piiExtractionTargets",
        "isCollection": true
      },
      "PersonFullName": {
        "type": "text",
        "isCollection": false
      }
    },
    "output": {
      "RiskAssessment": {
        "type": "riskAssessment",
        "isCollection": false
      },
      "ResultCsvFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "detectQr",
    "actionName": "Detect QR code",
    "input": {
      "ImageId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "DetectedObjects": {
        "type": "detectedObject",
        "isCollection": true
      }
    },
    "settings": {}
  },
  {
    "actionId": "mergePdf",
    "actionName": "Merge pdf files",
    "input": {
      "PdfFileIdList": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "PdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "combineConditions",
    "actionName": "Combine conditions",
    "input": {
      "FirstCondition": {
        "type": "boolean",
        "isCollection": false
      },
      "SecondCondition": {
        "type": "boolean",
        "isCollection": false
      }
    },
    "output": {
      "ConditionResult": {
        "type": "boolean",
        "isCollection": false
      }
    },
    "settings": {
      "AndCondition": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "getPageText",
    "actionName": "Get page text",
    "input": {
      "ShouldOcr": {
        "type": "boolean",
        "isCollection": false
      },
      "PageImageId": {
        "type": "fileId",
        "isCollection": false
      },
      "PageImageDimensions": {
        "type": "dimensions",
        "isCollection": false
      },
      "PagePdfFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "TextJsonFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "extractDocumentGroupOutput",
    "actionName": "Extract document group output",
    "input": {
      "DocumentGroupId": {
        "type": "text",
        "isCollection": false
      },
      "DocumentIdsToExtract": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "PdfFileIds": {
        "type": "fileId",
        "isCollection": true
      },
      "AggregatedDocumentData": {
        "type": "aggregatedDocumentData",
        "isCollection": true
      }
    },
    "settings": {
      "PdfFileIdTarget": {
        "type": "text",
        "isCollection": false
      },
      "DocumentTypeTarget": {
        "type": "text",
        "isCollection": false
      },
      "ExtractedDataTarget": {
        "type": "text",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "crossMatchData",
    "actionName": "Cross-match data from documents",
    "input": {
      "InputData": {
        "type": "aggregatedDocumentData",
        "isCollection": true
      },
      "ExternalSourceData": {
        "type": "externalSourceData",
        "isCollection": false
      }
    },
    "output": {
      "CrossMatchResult": {
        "type": "crossMatchResult",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "executeLlmPrompt",
    "actionName": "Execute LLM prompt",
    "input": {
      "UserText": {
        "type": "text",
        "isCollection": false
      },
      "TextFileIds": {
        "type": "fileId",
        "isCollection": true
      },
      "InputData": {
        "type": "any",
        "isCollection": true
      }
    },
    "output": {
      "PromptResponseFileId": {
        "type": "fileId",
        "isCollection": false
      },
      "PromptResponseText": {
        "type": "text",
        "isCollection": false
      }
    },
    "settings": {
      "AiSettings": {
        "type": "aiSettings",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "summarizeText",
    "actionName": "Summarize provided text",
    "input": {
      "UserText": {
        "type": "text",
        "isCollection": false
      },
      "TextFileIds": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "PromptResponseFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {
      "AiSettings": {
        "type": "aiSettings",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "speechToText",
    "actionName": "Transcribe audio file",
    "input": {
      "AudioFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "TranscriptionTextFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {
      "IsVerbose": {
        "type": "boolean",
        "isCollection": false
      },
      "OutputLanguage": {
        "type": "text",
        "isCollection": false
      },
      "RemoveSilence": {
        "type": "boolean",
        "isCollection": false
      },
      "Segmentize": {
        "type": "boolean",
        "isCollection": false
      },
      "EnabledSpeakerLabels": {
        "type": "boolean",
        "isCollection": false
      },
      "SpeakersExpected": {
        "type": "integer",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "createEventTimeline",
    "actionName": "Create event timeline from provided texts",
    "input": {
      "UserText": {
        "type": "text",
        "isCollection": false
      },
      "TextFileIds": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "PromptResponseFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {
      "AiSettings": {
        "type": "aiSettings",
        "isCollection": false
      },
      "LevelOfDetail": {
        "type": "text",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "fillForm",
    "actionName": "Fill form",
    "input": {
      "UserText": {
        "type": "text",
        "isCollection": false
      },
      "TextFileIds": {
        "type": "fileId",
        "isCollection": true
      },
      "Form": {
        "type": "text",
        "isCollection": false
      },
      "FormFileIds": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "PromptResponseFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {
      "AiSettings": {
        "type": "aiSettings",
        "isCollection": false
      },
      "ShowConfidence": {
        "type": "boolean",
        "isCollection": false
      },
      "ShowReasoning": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "answerQuestions",
    "actionName": "Answer provided questions",
    "input": {
      "Questions": {
        "type": "text",
        "isCollection": true
      },
      "TextFileIds": {
        "type": "fileId",
        "isCollection": true
      }
    },
    "output": {
      "PromptResponseFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "settings": {
      "AiSettings": {
        "type": "aiSettings",
        "isCollection": false
      },
      "ShowConfidence": {
        "type": "boolean",
        "isCollection": false
      },
      "ShowReasoning": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "runWorkflow",
    "actionName": "Run workflow",
    "input": {
      "FileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {},
    "settings": {
      "WorkflowId": {
        "type": "text",
        "isCollection": false
      },
      "FailOnChildJobFailure": {
        "type": "boolean",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "parseEmail",
    "actionName": "Parse email",
    "input": {
      "EmailFileId": {
        "type": "fileId",
        "isCollection": false
      }
    },
    "output": {
      "ParsedEmail": {
        "type": "parsedEmail",
        "isCollection": false
      }
    },
    "settings": {}
  },
  {
    "actionId": "makeHttpRequest",
    "actionName": "Make HTTP request",
    "input": {
      "Url": {
        "type": "text",
        "isCollection": false
      },
      "RequestHeaders": {
        "type": "stringDictionary",
        "isCollection": false
      },
      "RequestBody": {
        "type": "any",
        "isCollection": false
      },
      "RequestQueryParameters": {
        "type": "stringDictionary",
        "isCollection": false
      }
    },
    "output": {
      "ResponseCode": {
        "type": "integer",
        "isCollection": false
      },
      "ResponseBody": {
        "type": "text",
        "isCollection": false
      },
      "ResponseHeaders": {
        "type": "stringDictionary",
        "isCollection": false
      }
    },
    "settings": {
      "HttpMethod": {
        "type": "text",
        "isCollection": false
      }
    }
  },
  {
    "actionId": "route",
    "actionName": "Route workflow execution paths",
    "input": {},
    "output": {
      "MatchedRoutes": {
        "type": "text",
        "isCollection": true
      }
    },
    "settings": {
      "Routes": {
        "type": "routeDefinition",
        "isCollection": true
      },
      "DefaultRouteKey": {
        "type": "text",
        "isCollection": false
      }
    }
  }
]